import { render } from "./OrderHistoryItem.vue?vue&type=template&id=3c227d74&scoped=true"
import script from "./OrderHistoryItem.vue?vue&type=script&lang=js"
export * from "./OrderHistoryItem.vue?vue&type=script&lang=js"

import "./OrderHistoryItem.vue?vue&type=style&index=0&id=3c227d74&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\wwwda\\OneDrive\\Desktop\\проекты-и-учебные-файлы-front\\pizzares\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c227d74"]])

export default __exports__